<template>
  <div class="seatmap-content w-100">
    <div class="scrollable-seatmap" style="    height: calc(100vh - 89px);">
      <SeatMap
        v-if="seatmapData"
        :seatmap-data="seatmapData"
        :show-bays="showBays"
        :show-attributes="showAttributes"
        :scale="scale"
        :show-nose-cone="showNoseCone"
        class="seatmap"
        :class="isLoading ? 'seat-map-loading' : '' "
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios'

import SeatMap from '@components/flight/SteatMap.vue'



export default {
  components: {
    SeatMap,
  },
  props: {
    scale: {
      type: Boolean,
    },
    showBays: {
      type: Boolean,
    },
    showAttributes: {
      type: Boolean,
    },
  },
  data() {
    return {
      // showBays: true,
      showNoseCone: true,
      // showAttributes: true,
      seatmapData: [],
      lastUpdated: [{ type: 'seatmaplist', timestamp: null }],
      isLoading: false,
      sideBarVisible: true,
      flightId: null,
    }
  },
  computed: {
    selectedFlightId() {
      return this.$store.getters['flights/getSelectedFlightId']
    },
  },
  watch: {
    selectedFlightId: {
      immediate: true,
      handler(flightId) {
        this.flightId = flightId
        this.getData(flightId)
      },
    },
  },
  mounted() {
    this.getData(this.selectedFlightId)
  },
  methods: {
    getData(flightId) {
      if (!flightId) {
        flightId = this.$route.params.flightId
      }
      this.isLoading = true
      axios
        .get(`${this.$config.apiBaseUrl}seatmap/flightid/${flightId}`)
        .then((response) => {
          const data = response.data.Results[0]
          // Update the timestamp
          const seatmaplist = this.lastUpdated.findIndex(
            (obj) => obj.type === 'seatmaplist'
          )
          this.lastUpdated[seatmaplist].timestamp = response.data.Timestamp

          data.forEach((element, index) => {
            element.id = index
          })
          // Process data
          this.seatmapData = data
        })
        .catch((error) => {
          console.log(error)
          const seatmaplist = this.lastUpdated.findIndex(
            (obj) => obj.type === 'seatmaplist'
          )
          this.lastUpdated[seatmaplist].timestamp = 'FAILED'
        })
        .finally(() => (this.isLoading = false))
    },
  },
}
</script>

<style scoped>
.seatmap {
  opacity: 1;
  transition: all 1s;
}
.seat-map-loading {
  opacity: 0;
}
</style>